module.exports = __webpack_public_path__ + "img/Frame 12@2x.39fe2021.png";